export const LOGGER_LOAD_PREVIEW_LOGS_BEGIN = 'LOGGER_LOAD_PREVIEW_LOGS_BEGIN';
export const LOGGER_LOAD_PREVIEW_LOGS_SUCCESS = 'LOGGER_LOAD_PREVIEW_LOGS_SUCCESS';
export const LOGGER_LOAD_PREVIEW_LOGS_FAILURE = 'LOGGER_LOAD_PREVIEW_LOGS_FAILURE';
export const LOGGER_LOAD_PREVIEW_LOGS_DISMISS_ERROR = 'LOGGER_LOAD_PREVIEW_LOGS_DISMISS_ERROR';
